export enum TextBlockType {
  LZ = 'LZ',
  ABS = 'ABS',
}

export interface ITextBlock {
  _id?: string;
  title: string;
  description: string;
  type?: TextBlockType;
  createdAt?: Date;
  updatedAt?: Date;
}
